import React from 'react';
import {FORM_FIELDS_INITIAL_RULE_LOOKUP_TABLE} from '../../../../../constants';
const OtherSweepInstructions = ({item,pageJson,sweepParticipantsAccounts,translations,translateWordForOption}) => {
  if(item !== undefined) {
    var visibleFields = FORM_FIELDS_INITIAL_RULE_LOOKUP_TABLE['sweep-other-sweep-instructions'][sweepParticipantsAccounts.sweepType.value]['visibleFields'];
    // let OtherSweep = visibleFields.map((fieldsData) => {
    //       console.log(fieldsData);
    //       return(<div><dt>{translations(pageJson.fieldsData)}</dt>
    //       <dd>{item.fieldsData}</dd></div>)
    //  })
    //visibleFields.includes('')
    return (
      <div className="cc-detail-container gdocs-mleft-25">
        <div className="cc-detail-container__heading">{translations(pageJson.accordion3)}</div>
        <div className="cc-detail-container__content">
          <dl className="cc-detail-container__horizontal-row">
            {
              visibleFields.includes('pegBalance')
              ? [
                  <dt>{translations(pageJson.pegBalance)}</dt>,
                  <dd>{item.pegBalance}</dd>
                ]
              : null
            }

            {
              visibleFields.includes('minimumBalance')
              ? [
                  <dt>{translations(pageJson.minimumBalance)}</dt>,
                  <dd>{item.minimumBalance}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('targetBalance')
              ? [
                  <dt>{translations(pageJson.targetBalance)}</dt>,
                  <dd>{item.targetBalance}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('minSweepAmountIN')
              ? [
                  <dt>{translations(pageJson.minimumAmountIN)}</dt>,
                  <dd>{item.minSweepAmountIN}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('maxSweepAmountIN')
              ? [
                  <dt>{translations(pageJson.maximumAmountIN)}</dt>,
                  <dd>{item.maxSweepAmountIN}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('minSweepAmountOUT')
              ? [
                  <dt>{translations(pageJson.minimumAmountOUT)}</dt>,
                  <dd>{item.minSweepAmountOUT}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('maxSweepAmountOUT')
              ? [
                  <dt>{translations(pageJson.maximumAmountOUT)}</dt>,
                  <dd>{item.maxSweepAmountOUT}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('creditSweepTop')
              ? [
                  <dt>{translations(pageJson.creditTopUp)}</dt>,
                  <dd>{item.creditSweepTop}</dd>
                ]
              : null
            }
            {
              visibleFields.includes('debitSweepTopUp')
              ? [
                [
                    <dt>{translations(pageJson.debitTopUp)}</dt>,
                    <dd>{item.debitSweepTopUp}</dd>
                  ]
                ]
              : null
            }
          </dl>
        </div>
      </div>
    )
  }else {
    return null;
  }
}

export default OtherSweepInstructions



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/CCPreview/SweepInstruction/OtherSweepInstructions.js